var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
/**
 * A component that lets users show and hide sections of related content on a page.
 *
 * @example
 * <Accordion>
 *   <AccordionItem>
 *      <AccordionTrigger>{item.value}</AccordionTrigger>
 *      <AccordionPanel>{iten.description}</AccordionPanel>
 *   </AccordionItem>
 * </Accordion>
 *
 */
export function Accordion(_a) {
    var { hiddenUntilFound = true } = _a, props = __rest(_a, ["hiddenUntilFound"]);
    return _jsx(BaseAccordion.Root, Object.assign({ hiddenUntilFound: hiddenUntilFound }, props));
}
